import SquareIcon from '@mui/icons-material/Square';
import { createColumnHelper } from '@tanstack/react-table';
import React from 'react';
import { LocationGroup } from '../../../types';
import { L } from 'harmony-language';

export const useLocationGroupColumns = () => {
    const columnHelper = createColumnHelper<LocationGroup>();

    const columns = React.useMemo(() => ([
        columnHelper.accessor('name', {
            header: L.name(),
            cell: (info) => info.getValue(),
            enableColumnFilter: false,
        }),
        columnHelper.accessor('hexColor', {
            header: L.color(),
            cell: (info) => <SquareIcon style={{ color: info.getValue() }} />,
            enableColumnFilter: false,
            enableSorting: false,
        })
    ]), []);

    return columns;
}